export const ladderPrices = [
  {
    id: "LP001",
    userType: "居民用户",
    region: "全市",
    effectiveDate: "2025-01-01",
    endDate: null,
    status: "执行中",
    tiers: [
      { tier: 1, minVolume: 0, maxVolume: 240, price: 2.63, unit: "元/m³", description: "第一阶梯（年用气量≤240m³）" },
      { tier: 2, minVolume: 240, maxVolume: 480, price: 2.89, unit: "元/m³", description: "第二阶梯（年用气量240-480m³）" },
      { tier: 3, minVolume: 480, maxVolume: null, price: 3.47, unit: "元/m³", description: "第三阶梯（年用气量>480m³）" },
    ],
  },
  {
    id: "LP002",
    userType: "小餐饮业",
    region: "全市",
    effectiveDate: "2025-01-01",
    endDate: null,
    status: "执行中",
    tiers: [
      { tier: 1, minVolume: 0, maxVolume: 5000, price: 3.45, unit: "元/m³", description: "基础用量（年用气量≤5000m³）" },
      { tier: 2, minVolume: 5000, maxVolume: 15000, price: 3.78, unit: "元/m³", description: "中等用量（年用气量5000-15000m³）" },
      { tier: 3, minVolume: 15000, maxVolume: null, price: 4.12, unit: "元/m³", description: "大量用气（年用气量>15000m³）" },
    ],
  },
  {
    id: "LP003",
    userType: "大型企事业",
    region: "全市",
    effectiveDate: "2025-01-01",
    endDate: null,
    status: "执行中",
    tiers: [
      { tier: 1, minVolume: 0, maxVolume: 50000, price: 3.20, unit: "元/m³", description: "基础用量（年用气量≤50000m³）" },
      { tier: 2, minVolume: 50000, maxVolume: 200000, price: 3.50, unit: "元/m³", description: "中等用量（年用气量50000-200000m³）" },
      { tier: 3, minVolume: 200000, maxVolume: null, price: 3.80, unit: "元/m³", description: "大量用气（年用气量>200000m³）" },
    ],
  },
  {
    id: "LP004",
    userType: "特殊行业",
    region: "全市",
    effectiveDate: "2025-01-01",
    endDate: null,
    status: "执行中",
    tiers: [
      { tier: 1, minVolume: 0, maxVolume: null, price: 4.50, unit: "元/m³", description: "统一价格" },
    ],
  },
];

export const priceHistory = [
  { id: "PH001", userType: "居民用户", region: "全市", price: "2.50/2.75/3.30", effectiveDate: "2023-01-01", endDate: "2024-12-31", operator: "系统管理员", reason: "年度价格调整" },
  { id: "PH002", userType: "小餐饮业", region: "全市", price: "3.20/3.50/3.85", effectiveDate: "2023-01-01", endDate: "2024-12-31", operator: "系统管理员", reason: "年度价格调整" },
  { id: "PH003", userType: "居民用户", region: "全市", price: "2.63/2.89/3.47", effectiveDate: "2025-01-01", endDate: null, operator: "张主任", reason: "2025年度价格调整，经市发改委批准" },
];
